import React from 'react';
import './SupplierStyle.css';

const GetProductByIdFromSupplier = ({product}) => {
    return(
        <div className="container-fluid product-details-page">
            <h5>Product ID: {product.productId}</h5>
            <h5><span className='detail'>Product Name:</span> {product.productName}</h5>
            <h5><span className='detail'>Product Description:</span> {product.productDescription}</h5>
            <h5><span className='detail'>Quantity:</span> {product.productQuantity}</h5>
            <h5><span className='detail'>Type:</span> {product.productType}</h5>
            <h5><span className='detail'>Date:</span> {product.date}</h5>
        </div>
    );
};

export default GetProductByIdFromSupplier;